var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16.945,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.636 19.532c0-3.3108 0-4.9662 1.0285-5.9947 1.0285-1.0285 2.6839-1.0285 5.9947-1.0285h7.3743c0.76143 0 1.1421 0 1.4593 0.0588 1.4295 0.26494 2.548 1.3833 2.8129 2.8128 0.05882 0.31725 0.05882 0.69802 0.05882 1.4593v3.6287c0 3.3107 0 4.9661-1.0285 5.9947-1.0285 1.0285-2.684 1.0285-5.9947 1.0285h-4.6822c-3.3108 0-4.9662 0-5.9947-1.0285-1.0285-1.0286-1.0285-2.684-1.0285-5.9947z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.897 20-5.7942 3.2439v-6.4877z",
    fill: "#f00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.0be74b113ac2ea50887f59ce47f14b13.svg";
export { ForwardRef as ReactComponent };